<template>
  <div class="my_form">
    <el-form class="form" :model="form" ref="ruleForm" inline>
      <el-row>
          <el-col :span="8">
            <el-form-item label="单位员工:" prop="status">
              <el-select v-model="form.staff_name" filterable>
                  <el-option v-for="item in peopleList" :key="item.userId" :label="item.showName" :value="item.userId" />
              </el-select>
            </el-form-item>
          </el-col>
        <el-col :span="8">
          <el-form-item label="证照编号:" prop="license_no">
            <el-input v-model="form.license_no"/>
          </el-form-item>
        </el-col>
          <el-col :span="8">
            <el-form-item label="状态:" prop="status">
              <el-select v-model="form.status" filterable>
                  <el-option v-for="(item,key) in licenseStatus" :key="key" :label="item" :value="key" />
              </el-select>
            </el-form-item>
          </el-col>
        <el-col :span="8">
          <el-form-item label="证照名称:" prop="license_name">
            <el-input v-model="form.license_name"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="到期日期:" prop="license_name">
            <el-date-picker
              v-model="time"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="action">
            <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
            <el-button size="small" @click="resetForm">重置</el-button>
        </el-col>
        <el-col :span="24" class="action">
            <el-button  size="small" type="danger" icon='el-icon-delete' @click='handleDeleteList' plain>批量删除</el-button>
            <el-button size="small" type="primary" @click="handleOpenDetail({})">新建</el-button>
            <Upload name="导入" @submitForm="submitForm" />
        </el-col>
      </el-row>
    </el-form>
    <STable :columns="columns" :loadData="loadData" ref="table">
      <template #delete="record">
        <el-checkbox-group v-model="checkList">
          <el-checkbox :label='record.row.license_id'></el-checkbox>
        </el-checkbox-group>
      </template>
      <template #sn='{ $index }'>
        {{ $index + 1 }}
      </template>
      
      <template #status="record">
        {{licenseStatus[record.row.status]}}
      </template>
      <template #license_type="record">
        {{licenseType[record.row.license_type]}}
      </template>
      <template #staff_name="record">
        {{ filterName(record) }}
      </template>
      
      <template #action="record">
          <a href="javascript:;" class="success" @click="handleOpenDetail(record.row)">编辑</a>
          <a class="delete" href="javascript:;" @click="handleDelete(record.row)">删除</a>
      </template>
    </STable>
    <ItemMoudle :visible.sync='visible' :record='record' @submitForm='submitForm' />
  </div>
</template>

<script>
import dayjs  from "dayjs";
import { LicenseManagement } from '@/api/Licence'
import { licenseType, licenseStatus} from '@/utils/data'
import STable from '@/components/STable'
import Upload from './modules/Upload.vue'
import ItemMoudle from './modules/ItemMoudle.vue';
export default {
  components: {
    STable,
    ItemMoudle,
    Upload
  },
  data () {
    return {
      form: {
        staff_name:'',
        license_no: '',
        status: '',
        license_name: ''
      },
      time:[],
      columns: [
        {
          label: '选择',
          scopedSlots: 'delete',
          width: 100
        },
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 100
        },
        {
          label: '单位员工',
          scopedSlots: 'staff_name',
          ellipsis: true,
          width: 200
        },
        {
          label: '证照类型',
          scopedSlots: 'license_type',
          ellipsis: true,
          width: 200
        },
        {
          label: '证照编号',
          prop: 'license_no',
          width: 300,
          ellipsis: true
        },
        {
          label: '证照名称',
          prop: 'license_name',
          width: 350,
          ellipsis: true
        },
        {
          label: '状态',
          scopedSlots: 'status',
          width: 150,
          ellipsis: true
        },
        {
          label: '操作',
          scopedSlots: 'action',
          width: 150,
          fixed: 'right',
          ellipsis: true
        }
      ],
      loadData: (pageParam) => {
        const arr = []
        for (var key in this.form) {
          if (this.form[key]) {
            arr.push({
              columnName: key,
              columnValue: this.form[key],
              filterType: key === 'staff_name' ? 1 :  3,
              tableName: 'oa_form_staff_license'
            })
          }
        }
        if(this.time.length){
          arr.push({
            columnName: "expire_date",
            columnValueEnd: dayjs(this.time[1]).format('YYYY-MM-DD') +  " 23:59:59",
            columnValueStart: dayjs(this.time[0]).format('YYYY-MM-DD') + " 00:00:00",
            filterType: 2,
            tableName: "oa_form_staff_license"
          })
        }
        return LicenseManagement.getList(this, {
          datasourceId: '1631157465292738560',
          filterDtoList: arr,
          pageParam
        }).then(rs => rs)
      },
      licenseType,
      licenseStatus,
      visible: false,
      record: {},
      checkList: [], // 复选框
      peopleList: []// 人员
    }
  },
  created () {
    this.getPeople()
  },
  methods: {
    getPeople () {
      LicenseManagement.getPeopleList(this, {}).then(res => {
        this.peopleList = res.data.dataList
      })
    },
    handleOpenDetail (record) {
      this.record = record
      this.visible = true
    },
    submitForm (flag = true) {
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    resetForm () {
      this.form = {
        license_no: '',
        status: '',
        license_name: ''
      }
      this.time = []
      this.submitForm()
    },
    filterName(record){
      const item = this.peopleList.find(item => item.userId == record.row.staff_name*1)
      return item ? item.showName : ''
    },
    handleDelete (record) {
      this.$confirm('是否删除当前数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        LicenseManagement.deleteoaFormStaffLicenser(this, {datasourceId: '1631157465292738560', dataId: record.license_id}).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.submitForm(false)
        })
      })
    },
    // 批量删除
    handleDeleteList () {
      this.$confirm('是否删除当前数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        LicenseManagement.deleteoaFormStaffLicenserList(this, {datasourceId: '1631157465292738560', dataIdList: this.checkList}).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.submitForm(false)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/element-variables.scss';
  .title {
    border: 1px solid #EDEDED;
    border-left-width: 5px;
    border-left-color: $--color-primary;
    margin-bottom: 20px;
  }

  .title p {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    margin: 0px;
    padding-left: 20px;
  }

  .title p span {
    font-size: 20px;
    color: $--color-primary;
  }

  .item-list {
    margin: 0px;
  }
  .item-list li {
    margin: 10px 0px;
  }

  .item {
    height: 48px;
    display: flex;
    align-items: center;
  }
</style>
